import axios from 'axios'

const state = {
  loading: false,
  services: {},
  categories: [],
  showFilters: true,
  data: {
    categoriesFiltered: [],
    category: {},
  },
}

const getters = {
  data(state) {
    return state.data
  },
  getCategoriesFiltered(state) {
    return state.data.categoriesFiltered
  },
  getShowFilters(state) {
    return state.showFilters
  },
  getServices(state) {
    return state.services
  },
  getCategories(state) {
    return state.categories
  },
  getActiveTypeFilter(state) {
    return state.activeTypeFilter
  },
}

const mutations = {
  setShowFilters(state, show) {
    state.showFilters = show
  },
  setServices(state, data) {
    state.services = data
  },
  setCategories(state, data) {
    state.categories = data
  },
  setCategoriesFiltered(state) {
    return state.data.categoriesFiltered
  },
  setActiveTypeFilter(state, data) {
    state.activeTypeFilter = data
  },
}

const actions = {
  getServices({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/api/services',
        data: {
          // type: state.activeTypeFilter,
          categories: state.data.categoriesFiltered,
          // loc: state.data.loc
        },
      })
        .then((response) => {
          commit('setServices', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getCategories({ commit, dispatch, state }, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/api/categories',
        data: '',
      })
        .then((response) => {
          commit('setCategories', response.data)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPublicFolder({ commit, dispatch, state }, data) {
    let url = '/endpoint/public-folders/' + data.unique_folder_id
    let loading = true
    let records = []
    axios({
      method: 'get',
      url: url,
    })
      .then((response) => {
        records = response.data
        loading = false
      })
      .catch((error) => {
        // console.log(error)
      })

    /*    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: url,
        responseType: 'json'
      })
        .then(response => {
          resolve(response)
          return response.data
        })
        .catch(error => {
          reject(error)
        })
    })*/

    if (!loading) {
      return records
    }
  },
  toggleShowFilters({ commit }, data) {
    commit('setShowFilters', data.showFilters)
  },
  updateActiveTypeFilter({ commit }, data) {
    commit('setActiveTypeFilter', data)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
